export default {
    
    show: { method: 'post', url: 'v2/movida/mfa/show' },
    register: { method: 'post', url: 'v2/movida/mfa/register' },
    delete: { method: 'post', url: 'v2/movida/mfa/delete' },
    confirm: { method: 'post', url: 'v2/movida/mfa/confirm' },
    default: { method: 'post', url: 'v2/movida/mfa/default' },
}